"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _carbonComponentsReact = require("carbon-components-react");
var _ = _interopRequireDefault(require("@carbon/icons-react/lib/maximize/24.js"));
var _2 = _interopRequireDefault(require("@carbon/icons-react/lib/minimize/24.js"));
var _CurrencyFormatter = _interopRequireDefault(require("../../../common/Formatters/CurrencyFormatter"));
var _NumberInput = _interopRequireDefault(require("../../NumberInput/NumberInput"));
var _AccordionFIBUItem = _interopRequireDefault(require("./AccordionFIBUItem"));
var _statusEnum = require("../../../common/statusEnum");
var _Total = _interopRequireDefault(require("../Total/Total"));
var _Checkbox = _interopRequireDefault(require("../../Checkbox/Checkbox"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
(function () {
  const styles = ":export {\n  primary-SIAblack: #000000;\n  primary-SIAgraydark: #4c4c4c;\n  primary-SIAgrayMiddle: #a8a8a8;\n  primary-SIAgray: #d4d4d4;\n  primary-SIAgrayLight: #e8e8e8;\n  primary-SIAgrayVeryLight: #f4f4f4;\n  primary-SIAwhite: #fff;\n  primary-SIAred: #e41b13;\n  primary-SIAredDark: #99100a;\n  secondary-SIAazure: #8caddb;\n  secondary-SIAazureLight: #e9eff7;\n  secondary-SIAbronze: #b1997e;\n  secondary-SIAbronzeLight: #efebe5;\n  secondary-SIAgreen: #2fb789;\n  secondary-SIAgreenLight: #ecf7f3;\n  secondary-SIAorange: #f3743d;\n  secondary-SIAorangeLight: #fbf1ec;\n  secondary-SIArose: #e6005f;\n  secondary-SIAroseLight: #fcf2f7;\n  secondary-SIAyellow: #dacd7e;\n  secondary-SIAyellowLight: #faf8ed; }\n\n.fibu-accordion {\n  width: 600px; }\n  .fibu-accordion .all-open {\n    float: right;\n    width: fit-content; }\n  .fibu-accordion .remove-top-border {\n    border-top: none;\n    width: 600px; }\n  .fibu-accordion .bx--accordion__heading {\n    flex-direction: row;\n    height: 40px;\n    margin-bottom: -1px;\n    width: 600px; }\n    .fibu-accordion .bx--accordion__heading .bx--accordion__title {\n      font-size: 16px;\n      user-select: text;\n      cursor: text; }\n    .fibu-accordion .bx--accordion__heading .icon {\n      padding-right: 10px;\n      border-width: 1px; }\n  .fibu-accordion .bx--accordion__heading:hover::before {\n    content: unset; }\n  .fibu-accordion .bx--accordion__heading:focus {\n    outline: none; }\n  .fibu-accordion .bx--accordion__heading:hover {\n    background-color: var(--cds-hover-ui, #e5e5e5); }\n  .fibu-accordion .bx--accordion__content {\n    padding-right: 2rem;\n    padding-bottom: 0;\n    padding-top: 0px;\n    width: 600px; }\n  .fibu-accordion .fibu-accordion-content-wrapper {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: center;\n    height: auto;\n    padding-bottom: 0.5rem; }\n  .fibu-accordion .bx--accordion__tooltip {\n    color: #a8a8a8;\n    line-height: 16px;\n    font-size: 12px; }\n  .fibu-accordion .fibu-accordion-content-input {\n    max-width: 185px; }\n    .fibu-accordion .fibu-accordion-content-input .number-input {\n      margin-bottom: 0; }\n    .fibu-accordion .fibu-accordion-content-input input {\n      text-align: right;\n      width: 100%; }\n  .fibu-accordion .expansion-total {\n    display: flex;\n    flex-direction: row;\n    width: 390px; }\n    .fibu-accordion .expansion-total .icon {\n      padding-right: 0; }\n    .fibu-accordion .expansion-total p {\n      margin-left: auto;\n      padding-right: 1rem;\n      user-select: text;\n      cursor: text; }\n";
  const fileName = "AccordionFIBU_AccordionFIBU";
  const element = document.querySelector("style[data-sass-component='AccordionFIBU_AccordionFIBU']");
  if (!element) {
    const styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
const isUndefinedOrNull = val => {
  // Double Equals. Check for undefined or null
  return val == null;
};
const AccordionFIBU = _ref => {
  let {
    items,
    onChange,
    invalidText,
    grandTotalText,
    isInitialLoad,
    setParentStatus,
    onCheckBoxChange,
    translate,
    allowNegativesFormatting,
    isDisabled
  } = _ref;
  const defaultInvalid = {
    text: '',
    itemIds: [],
    rowIds: []
  };
  const [invalid, setInvalid] = (0, _react.useState)(defaultInvalid);
  const [rowAmounts, setRowAmounts] = (0, _react.useState)({});
  const [totals, setTotals] = (0, _react.useState)({});
  const [allOpen, setAllOpen] = (0, _react.useState)(false);
  const [grandTotal, setGrandTotal] = (0, _react.useState)(0);
  const firstInputRef = (0, _react.useRef)(null);
  const [isFirstItemOpen, setIsFirstItemOpen] = (0, _react.useState)(false);
  let allRowsFilled = false;
  const Icon = allOpen ? _2.default : _.default;
  (0, _react.useEffect)(() => {
    let initialRowAmounts = {};
    let initialTotals = {};
    items.forEach(item => {
      initialRowAmounts[item.id] = {};
      initialTotals[item.id] = {
        total: false
      };
      item.content.forEach(row => {
        initialRowAmounts[item.id][row.id] = isUndefinedOrNull(row.amount) ? null : row.amount;
      });
      initialTotals = {
        ...initialTotals,
        ...calculateTotalsForRow(initialRowAmounts, item.id)
      };
    });
    setRowAmounts(initialRowAmounts);
    setTotals(initialTotals);
    calculateGrandTotal(initialTotals);
    calculateInvalid();
  }, [items]);
  (0, _react.useEffect)(() => {
    const areAllRowsFilled = Object.entries(totals).every(_ref2 => {
      let [, total] = _ref2;
      return total.skipField || total.allRowsFilled;
    });
    if (!areAllRowsFilled) {
      setParentStatus(_statusEnum.statuses.INPROGRESS.id);
    } else {
      setParentStatus(_statusEnum.statuses.COMPLETE.id);
    }
  }, [totals]);
  const calculateInvalid = () => {
    setInvalid(prevState => ({
      text: invalidText,
      rowIds: [],
      itemIds: [...prevState.itemIds]
    }));
    let rowIds = [];
    let itemIds = [];
    items.forEach(item => {
      item.content.forEach(row => {
        if (isUndefinedOrNull(row.amount)) {
          rowIds.push(row.id);
          itemIds.push(item.id);
        }
      });
    });
    if (rowIds.length > 0) {
      setInvalid(prevState => ({
        text: invalidText,
        rowIds: [...rowIds],
        itemIds: [...prevState.itemIds, ...itemIds]
      }));
    }
  };
  const calculateTotalsForRow = (rowAmounts, itemId) => {
    let updatedTotals = {};
    let total = 0;
    allRowsFilled = true;
    Object.values(rowAmounts[itemId]).forEach(val => {
      if (isUndefinedOrNull(val)) {
        return allRowsFilled = false;
      }
      total += Number(val);
    });
    const isFilledWithZeros = Object.values(rowAmounts[itemId]).every(e => e == 0);
    const item = items.find(e => e.id === itemId);
    const skipField = item ? item.skipField : false;
    updatedTotals = {
      ...updatedTotals,
      [itemId]: {
        total: total,
        allRowsFilled: allRowsFilled && !isFilledWithZeros,
        skipField
      }
    };
    return updatedTotals;
  };
  const calculateGrandTotal = ts => {
    let updatedGrandTotal = 0;
    Object.keys(ts).forEach(key => {
      if (key !== '61') {
        updatedGrandTotal += ts[key].total;
      }
    });
    setGrandTotal(updatedGrandTotal);
    return updatedGrandTotal;
  };
  const onInputChange = (itemId, rowId, value) => {
    if (isUndefinedOrNull(value)) {
      value = null;
    }
    if (value === '-') {
      value = 0;
    }
    if (value === '' && allowNegativesFormatting) {
      value = null;
    }
    const updatedRowAmounts = {
      ...rowAmounts,
      [itemId]: {
        ...rowAmounts[itemId],
        [rowId]: value
      }
    };
    setRowAmounts(updatedRowAmounts);
    const updatedTotals = {
      ...totals,
      ...calculateTotalsForRow(updatedRowAmounts, itemId)
    };
    setTotals(updatedTotals);
    calculateGrandTotal(updatedTotals);
    onChange(updatedRowAmounts, updatedTotals);
  };
  (0, _react.useEffect)(() => {
    setIsFirstItemOpen(true);
    if (isInitialLoad && firstInputRef.current) {
      firstInputRef.current.focus();
    }
  }, [firstInputRef.current]);
  return /*#__PURE__*/_react.default.createElement(_carbonComponentsReact.Accordion, {
    className: "fibu-accordion"
  }, /*#__PURE__*/_react.default.createElement(Icon, {
    className: "all-open",
    onClick: () => {
      if (isInitialLoad && isFirstItemOpen) {
        setIsFirstItemOpen(false);
      }
      setAllOpen(!allOpen);
    }
  }), items.map((item, i) => {
    if (item.id !== 61) {
      return /*#__PURE__*/_react.default.createElement(_AccordionFIBUItem.default, {
        key: i,
        index: i,
        isOpen: isInitialLoad && i === 0 && isFirstItemOpen || allOpen,
        title: item.title,
        tooltip: item?.tooltip,
        total: totals[item.id]?.total,
        allRowsFilled: totals[item.id]?.skipField || totals[item.id]?.allRowsFilled
      }, !isDisabled && /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        id: item.id,
        onChange: (event, value) => onCheckBoxChange(item, value),
        label: translate('benchmarking.survey.company-overhead.accordion.checkbox.label'),
        value: item.skipField
      }), item.content.map((row, j) => {
        return /*#__PURE__*/_react.default.createElement("div", {
          key: row.id,
          className: "fibu-accordion-content-wrapper"
        }, /*#__PURE__*/_react.default.createElement("p", {
          className: "sia-text-06"
        }, row.label.replace(row.id, '')), /*#__PURE__*/_react.default.createElement("div", {
          className: "fibu-accordion-content-input"
        }, /*#__PURE__*/_react.default.createElement(_NumberInput.default, _extends({
          key: `${i}${j}`
        }, isInitialLoad && i === 0 && j === 0 && {
          ref: firstInputRef
        }, {
          id: row.id.toString(),
          label: "",
          placeholder: _CurrencyFormatter.default.formatAlternate(100, 'CHF'),
          value: row.amount,
          onChange: (event, value, error) => onInputChange(item.id, row.id, value),
          invalidText: invalid.rowIds.includes(row.id) && !isInitialLoad && invalid.text || '',
          disabled: item.skipField || isDisabled,
          formatting: "CHF",
          allowNegativesFormatting: allowNegativesFormatting,
          hardReset: item.skipField
        }))));
      }));
    }
  }), /*#__PURE__*/_react.default.createElement(_Total.default, {
    className: "sia-padding-02 sia-padding-04-bottom sia-padding-05-right",
    title: grandTotalText,
    value: _CurrencyFormatter.default.formatAlternate(grandTotal, 'CHF')
  }), items.filter(item => item.id === 61).map(salesItem => /*#__PURE__*/_react.default.createElement("div", {
    className: "sales-total",
    key: salesItem.id
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "sia-text-04"
  }, salesItem.title), /*#__PURE__*/_react.default.createElement(_NumberInput.default, {
    id: "sales-adjusted",
    label: "",
    placeholder: _CurrencyFormatter.default.formatAlternate(100, 'CHF'),
    value: salesItem.content[0]?.amount,
    onChange: (event, value, error) => onInputChange(salesItem.id, salesItem.content[0]?.id, value),
    invalidText: invalid.rowIds?.includes(62) && !isInitialLoad && invalid.text || '',
    formatting: "CHF",
    disabled: isDisabled
  }))));
};
AccordionFIBU.propTypes = {
  items: _propTypes.default.array,
  onChange: _propTypes.default.func,
  onCheckBoxChange: _propTypes.default.func,
  invalidText: _propTypes.default.string,
  grandTotalText: _propTypes.default.string,
  setParentStatus: _propTypes.default.func,
  translate: _propTypes.default.func,
  allowNegativesFormatting: _propTypes.default.bool
};
var _default = exports.default = AccordionFIBU;